import { render, staticRenderFns } from "./competeProjectList.vue?vue&type=template&id=46d85ad1&"
import script from "./competeProjectList.vue?vue&type=script&lang=js&"
export * from "./competeProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports